import Input from "../../../common/Input";

const PrimaryDetails = ({
  formik,
  handleFocus,
  isEdit,
  handleEditIconClick,
  handleBlur,
  editingField,
  isDisabled,
}) => {
  const { handleChange, values, errors, touched, setFieldTouched } = formik;

  return (
    <div className="mb-3">
      <h2 className="text-black-lose text-[13px] font-medium mb-2">Primary</h2>
      <div className="grid grid-cols-10 gap-[8px]">
        {values.doctorDetails.DID && (
          <div className="col-span-5 lg:col-span-2">
            <Input
              placeholder="Enter"
              inputBox="mb-0"
              type="text"
              labelName="Doctor ID"
              labelClassName="block text-primary-400 text-[13px] leading-[20px]"
              className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
              name="doctorDetails.DID"
              value={values.doctorDetails.DID}
              onChange={handleChange}
              disabled
            />
          </div>
        )}
        <div className="col-span-5 lg:col-span-2">
          <Input
            placeholder="Enter"
            inputBox="mb-0"
            type="text"
            id="contactNumber"
            labelName="Contact Number*"
            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
            className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
            name="doctorDetails.contactNumber"
            value={values.doctorDetails.contactNumber}
            onChange={(e) => {
              handleChange(e);
              setFieldTouched("doctorDetails.contactNumber", true, false); // Mark the field as touched
            }}
            onFocus={handleFocus}
            isError={
              touched?.doctorDetails?.contactNumber &&
              Boolean(errors?.doctorDetails?.contactNumber)
            }
            errorMessage={errors?.doctorDetails?.contactNumber}
            disabled={isDisabled}
            disabledClass="bg-primary-50 border-primary-50 "
          />
        </div>

        <div className="col-span-5 lg:col-span-2">
          <Input
            placeholder="Enter"
            inputBox="mb-0"
            type="text"
            id="doctorDetails.pin"
            // onFocus={() => handleFocus("doctorDetails.pin")}
            labelName="PIN-A (5-digit)*"
            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
            className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
            name="doctorDetails.pin"
            value={values.doctorDetails.pin}
            onChange={(e) => {
              handleChange(e);
              setFieldTouched("doctorDetails.pin", true, false); // Mark the field as touched
            }}
            isError={
              touched?.doctorDetails?.pin && Boolean(errors?.doctorDetails?.pin)
            }
            errorMessage={errors?.doctorDetails?.pin}
            disabled={isDisabled && editingField !== "doctorDetails.pin"}
            showEditIcon={isEdit}
            onBlur={() => (handleBlur ? handleBlur("doctorDetails.pin") : null)}
            onEditClick={() => handleEditIconClick("doctorDetails.pin")}
            disabledClass="bg-primary-50 border-primary-50 "
          />
        </div>

        <div className="col-span-5 lg:col-span-2">
          <Input
            placeholder="Enter"
            inputBox="mb-0"
            type="text"
            id="doctorDetails.pinB"
            labelName="PIN-B (5-digit)*"
            labelClassName="block text-primary-400 text-[13px] leading-[20px]"
            className="border-none bg-transparent shadow-none outline-none placeholder:text-secondry-600 w-full h-[24px]"
            name="doctorDetails.pinB"
            value={values.doctorDetails.pinB}
            onChange={(e) => {
              handleChange(e);
              setFieldTouched("doctorDetails.pinB", true, false); // Mark the field as touched
            }}
            isError={
              touched?.doctorDetails?.pinB &&
              Boolean(errors?.doctorDetails?.pinB)
            }
            errorMessage={errors?.doctorDetails?.pinB}
            disabled={isDisabled && editingField !== "doctorDetails.pinB"}
            showEditIcon={isEdit}
            onBlur={() =>
              handleBlur ? handleBlur("doctorDetails.pinB") : null
            }
            onEditClick={() => handleEditIconClick("doctorDetails.pinB")}
            disabledClass="bg-primary-50 border-primary-50 "
          />
        </div>
      </div>
    </div>
  );
};

export default PrimaryDetails;
